import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'

const CheckoutCard = (props) => {
    const {food_image, food_name, price, count} = props.order;
  return (
    <div className="card mb-3" style={{ width: "400px", height: '130px', border: 'none', borderRadius: '15px', backgroundColor: '#F5F5F5'}}>
      <div className="row g-0">
        <div className="col-md-4">
          <img src={food_image} alt="..." className="w-100" style={{display: 'block', margin: '8px 5px'}}/>
        </div>
        <div className="col-md-8">
          <div className="card-body">
            <p className="card-title">{food_name}</p>
            <div className="d-flex justify-content-between">
            <h4 style={{color: '#F91944'}}>${price}</h4>
            <div className="d-flex" style={{marginRight: '15px'}}>
            <FontAwesomeIcon icon={faMinus} size="sm" style={{color: 'gray', marginTop: '8px', marginRight: '10px'}}/>
            <p style={{background: 'white', width: '30px', height: '30px', textAlign: 'center', marginBottom: '10px', paddingTop: '5px',}}>{count}</p>
            <FontAwesomeIcon icon={faPlus} size="sm" style={{color: 'gray', marginTop: '8px', marginLeft: '10px'}}/>
            </div>
            </div>
            <small style={{color: 'gray'}}>
              Delivery free
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCard;
